import { axiosPost } from "@/services/axiosService";

export default function trackError(err: Error) {
  let error;
  try {
    error = {
      name: err.name ?? "",
      message: err.message ?? "",
      stack: err.stack ?? "",
      cause: err.cause ?? "",
      wholeErr: JSON.stringify(err),
    };
  } catch (err2) {
    console.log(err2);
    error = {
      name: err.name ?? "",
      message: err.message ?? "",
      stack: err.stack ?? "",
      cause: err.cause ?? "",
    };
  } finally {
    console.error(error);
    axiosPost("/liveBot/track-error", error).catch((err) => {
      console.log(err);
    });
  }
}
